import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    width: '375px',
    minHeight: 92,
    borderRadius: 4,
    boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '##F5F7FA',
    padding: 10,
    boxSizing: 'border-box',
    margin: '5px 0',
    cursor: 'pointer',
    display: 'flex',
    background: '#F5F7FA',
    border: '1px solid #E8E8E8',
    '&:hover': {
      background: '#eeeeee',
    },
  },
  cardRead: {
    width: '375px',
    minHeight: 92,
    borderRadius: 4,
    // boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.2)',
    padding: 10,
    boxSizing: 'border-box',
    margin: '5px 0',
    cursor: 'pointer',
    display: 'flex',
    background: '#FFFFFF',
    border: '1px solid #E8E8E8',
    '&:hover': {
      background: '#f5f5f5',
    },
  },
  row: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  row2: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e8e8e8',
    paddingBottom: 5,
    alignItems: 'center',
  },
  row2Span: {
    display: 'flex',
    alignItems: 'center',
  },
  flex: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  title: {
    fontSize: 12,
    fontFamily: 'Averta Bold',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#434343',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  date: {
    fontSize: 12,
    fontFamily: 'Averta Bold',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#999999',
  },
  des: {
    fontSize: 11,
    fontFamily: 'Averta light',
    fontWeight: 300,
    color: '#434343',
    marginTop: 7,
    flex: 1,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },

  avatar: {
    height: 30,
    width: 30,
    margin: 'auto 4px auto 0',
  },
  seen: {
    fontSize: '1rem',
    alignSelf: 'flex-end',
    color: '#f8b100',
  },
  opponentName: {
    fontSize: '10.5px',
  },
}));
